var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSchool(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7405 12.3162V15.7051C16.7405 15.879 16.6501 16.0405 16.5017 16.1314L11.9215 18.9378C11.7613 19.0359 11.5597 19.036 11.3995 18.9381L6.6339 16.0258C6.48527 15.935 6.39462 15.7733 6.39462 15.5992V12.4221H7.39462V15.3187L11.6599 17.9253L15.7405 15.425V12.3162H16.7405Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1602 15.1756V18.5115H11.1602V15.1756H12.1602Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3169 5.56385C11.4782 5.46357 11.6825 5.46341 11.844 5.56343L19.2836 10.1702C19.431 10.2614 19.5206 10.4226 19.5204 10.5959C19.5202 10.7693 19.4302 10.9302 19.2825 11.0211L11.8429 15.6013C11.6819 15.7004 11.4788 15.7003 11.318 15.6009L3.90479 11.0206C3.75755 10.9297 3.66783 10.769 3.6676 10.5959C3.66738 10.4228 3.75669 10.262 3.90369 10.1706L11.3169 5.56385ZM11.5812 6.57691L5.11687 10.5941L11.5812 14.5881L18.0687 10.5941L11.5812 6.57691Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0808 10.3835C11.0808 10.1073 11.3046 9.88348 11.5808 9.88348H19.2322C19.5084 9.88348 19.7322 10.1073 19.7322 10.3835V16.1287C19.7322 16.4048 19.5084 16.6287 19.2322 16.6287C18.9561 16.6287 18.7322 16.4048 18.7322 16.1287V10.8835H11.5808C11.3046 10.8835 11.0808 10.6596 11.0808 10.3835Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2058 16.6286C18.9701 16.6286 18.7791 16.8197 18.7791 17.0553C18.7791 17.2909 18.9701 17.4819 19.2058 17.4819C19.4414 17.4819 19.6324 17.2909 19.6324 17.0553C19.6324 16.8197 19.4414 16.6286 19.2058 16.6286ZM17.7791 17.0553C17.7791 16.2674 18.4178 15.6286 19.2058 15.6286C19.9937 15.6286 20.6324 16.2674 20.6324 17.0553C20.6324 17.8432 19.9937 18.4819 19.2058 18.4819C18.4178 18.4819 17.7791 17.8432 17.7791 17.0553Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchool);
export default __webpack_public_path__ + "static/media/school.a25620c4ed0f866fa1bd5e88a5641c3a.svg";
export { ForwardRef as ReactComponent };